import { render } from "./PublicBookingAttendance.vue?vue&type=template&id=050fa1a5&scoped=true"
import script from "./PublicBookingAttendance.vue?vue&type=script&lang=js"
export * from "./PublicBookingAttendance.vue?vue&type=script&lang=js"

import "./PublicBookingAttendance.vue?vue&type=style&index=0&id=050fa1a5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-050fa1a5"]])

export default __exports__